module.exports = __webpack_public_path__ + "static/media/burnerloader.17fb2141.gif";